// SupportPage.js

import React from 'react';
import SupportSection from '../components/support/SupportSection';
import RequestDeletionSection from '../components/support/RequestDeletionSection';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';

const SupportPage = () => {
    return (
        <div>
            <Header />
            <div className='support-page-container'>
                <div className='support-page-content'>
                    <SupportSection />
                    <RequestDeletionSection />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default SupportPage;
